module.exports = __webpack_public_path__ + "img/emitEmotioneditor05.f8aae6c4.png";